import { CSSObject } from '@emotion/react'

export const snapshotRender = {
  '& .collaboration-text-editor-container .CollaborationTextEditor': {
    position: 'relative',
    insetInlineStart: 16,
    insetBlockStart: 16,
    '.CollaborationTextEditorContent': {
      paddingBlockEnd: 48,
    },
    '.text-editor-connection-banner': {
      display: 'none',
    },
  },
} satisfies CSSObject
